import React from 'react';
import { Box, Typography, Paper, Container, Link } from '@mui/material';
import MainLayout from '../../components/layout/MainLayout';

const TermsOfServicePage: React.FC = () => {
  return (
    <MainLayout>
      <Container maxWidth="md">
        <Paper elevation={3} sx={{ p: 4, borderRadius: 2 }}>
          <Typography variant="h4" component="h1" gutterBottom align="center" color="primary">
            Terms of Service
          </Typography>
          
          <Typography variant="body1" paragraph sx={{ mt: 3, fontWeight: 'bold' }}>
            Effective Date: April 22, 2025
          </Typography>

          <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4, color: 'primary.main' }}>
            1. Use of the Site
          </Typography>
          <Typography variant="body1" paragraph>
            MathWiz League is an educational platform designed to support students in participating in math competitions.
            By using our site, you agree to use it only for lawful educational purposes.
          </Typography>

          <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4, color: 'primary.main' }}>
            2. Registration
          </Typography>
          <Typography variant="body1" paragraph>
            To participate in MathWiz League events, users (or their guardians) may be required to register and provide
            accurate information. You are responsible for maintaining the confidentiality of any account credentials and for
            all activities that occur under your account.
          </Typography>

          <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4, color: 'primary.main' }}>
            3. User Content
          </Typography>
          <Typography variant="body1" paragraph>
            You retain ownership of all answers and content submitted in response to math problems. By submitting content,
            you grant MathWiz League a non-exclusive, royalty-free license to use your submissions for scoring, feedback,
            and display during events.
          </Typography>

          <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4, color: 'primary.main' }}>
            4. Data Collection
          </Typography>
          <Typography variant="body1" paragraph>
            We only collect information provided during registration and any answers submitted for math problems. We do
            <Box component="span" sx={{ fontWeight: 'bold' }}> not</Box> sell or share this data with third parties.
          </Typography>

          <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4, color: 'primary.main' }}>
            5. Termination
          </Typography>
          <Typography variant="body1" paragraph>
            We reserve the right to terminate or restrict access to the platform for any reason, including violation of
            these Terms.
          </Typography>

          <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4, color: 'primary.main' }}>
            6. Modifications
          </Typography>
          <Typography variant="body1" paragraph>
            We may update these Terms from time to time. Continued use of the site after changes constitutes your
            acceptance of the revised Terms.
          </Typography>

          <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4, color: 'primary.main' }}>
            7. Contact
          </Typography>
          <Typography variant="body1" paragraph>
            If you have questions about these Terms, contact us at{' '}
            <Link href="mailto:contact@mathwizleague.com" underline="hover" color="primary">
              contact@mathwizleague.com
            </Link>.
          </Typography>
        </Paper>
      </Container>
    </MainLayout>
  );
};

export default TermsOfServicePage;